// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-drop-down__extended[data-v-220b811b] {\n  max-width: 200px !important;\n}", ""]);
// Exports
module.exports = exports;
